import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class ApiKeyDataService {
  
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  checkNameExists(name: string, apiKeyId: number, cancellation: Promise<any>): Promise<boolean> {
    const request = { name: name, apiKeyId: apiKeyId };
    return this.httpClient.getJsonAsync<boolean>('ApiKeys/CheckNameExists', request, cancellation, false);
  }

  deleteApiKeyAsync(id: number, timeout: Promise<any>): Promise<any> {
    return this.httpClient.postJsonAsync('ApiKeys/DeleteApiKey', id, timeout);
  }
}
